import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';

function getTokenFromSession(): string | null {
  const stored = sessionStorage.getItem('1000');
  if (!stored) {
    return null;
  }
  try {
    return  stored
  } catch {
    return null;
  }
}

function isTokenExpired(token: string): boolean {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return false;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payloadJson = atob(base64);
    const payload = JSON.parse(payloadJson);
    if (!payload || typeof payload.exp !== 'number') {
      return false;
    }
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
  } catch {
    return false;
  }
}
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authReq = req.clone({
    withCredentials: true
  });

  return next(authReq);
};
// export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
//   const token = getTokenFromSession();
//   if (!token) {
//     return next(req);
//   }

//   if (isTokenExpired(token)) {
//      const router = inject(Router);
//     router.navigate(['/login']);
//     return next(req);
//   }

//   const authReq = req.clone({
//     setHeaders: {
//       Authorization: `Bearer ${token}`
//     }
//   });

//   return next(authReq);
// };

